import React, { useState } from "react";
import { ListFilter } from "lucide-react";

export default function Table({ columns, rows, actions, pagination, act, filters, setFilters, onFilter }) {
  const [activeMenu, setActiveMenu] = useState(null);
  const [filterOpen, setFilterOpen] = useState({});
  const [filterValues, setFilterValues] = useState({ ...filters });

  const handleFilterChange = (key, value) => {
    setFilterValues((prev) => ({ ...prev, [key]: value }));
  };

  const handleFilterApply = (key) => {
    setFilters((prev) => ({ ...prev, [key]: filterValues[key] }));
    setFilterOpen((prev) => ({ ...prev, [key]: false }));
    // Removed direct onFilter call to avoid double API requests
  };

  return (
    <div className="bg-white mt-5 rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
      <div className="flex items-center justify-between px-4 md:px-6 py-3">
        <h3 className="font-semibold text-[#1D2035]">{pagination?.title || ""}</h3>
        <div className="flex items-center gap-2 text-sm">
          {actions?.map((action, idx) => (
            <button key={idx} className="px-3 py-1.5 rounded-md border border-gray-200 bg-white" onClick={action.onClick}>
              {action.label}
            </button>
          ))}
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full  text-sm">
          <thead>
            <tr className="text-gray-600 bg-[#fafafa]">
              <th className="p-3 w-10">
                <input type="checkbox" className="rounded border-gray-300" />
              </th>
              {columns.map((col, idx) => (
                <th key={idx} className="p-3 text-right font-medium relative">
                  <div className="flex items-center gap-1 cursor-pointer" onClick={() => setFilterOpen(f => ({...f, [col.accessor]: !f[col.accessor]}))}>
                    <div className="flex-1">
                      {col.header}
                    </div>
                    <button 
                      type="button"
                      className={`p-1 rounded hover:bg-gray-100 ${filterOpen[col.accessor] || filterValues[col.accessor] ? 'text-blue-600 bg-blue-50' : 'text-gray-400'}`}
                    >
                      <ListFilter size={16} />
                    </button>
                    {filterValues[col.accessor] && (
                      <span className="ml-1 flex items-center bg-blue-100 text-blue-700 px-2 py-0.5 rounded text-xs">
                        {col.filterType === 'select'
                          ? (col.options?.find(opt => opt.value === filterValues[col.accessor])?.label || filterValues[col.accessor])
                          : filterValues[col.accessor]}
                        <button
                          className="ml-1 text-blue-700 hover:text-red-600 focus:outline-none"
                          onClick={e => {
                            e.stopPropagation();
                            setFilterValues(f => ({ ...f, [col.accessor]: "" }));
                            setFilters(f => ({ ...f, [col.accessor]: "" }));
                            onFilter && onFilter();
                          }}
                        >
                          ×
                        </button>
                      </span>
                    )}
                  </div>
                  {filterOpen[col.accessor] && (
                    <div className="absolute right-0 mt-2 bg-white border border-gray-200 rounded-md shadow-lg p-2 z-20 min-w-[150px]">
                      {col.filterType === 'select' ? (
                        <select
                          className="border rounded px-2 py-1 w-full"
                          value={filterValues[col.accessor] || ""}
                          onChange={e => handleFilterChange(col.accessor, e.target.value)}
                          onKeyDown={e => {
                            if (e.key === 'Enter') handleFilterApply(col.accessor);
                          }}
                        >
                          <option value="">الكل</option>
                          {(col.options || []).map(opt => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                          ))}
                        </select>
                      ) : (
                        <input
                          className="border rounded px-2 py-1 w-full"
                          placeholder={col.header}
                          value={filterValues[col.accessor] || ""}
                          onChange={e => handleFilterChange(col.accessor, e.target.value)}
                          onKeyDown={e => {
                            if (e.key === 'Enter') handleFilterApply(col.accessor);
                          }}
                        />
                      )}
                      <button className="bg-blue-600 text-white px-3 py-1 rounded mt-2 w-full" onClick={() => handleFilterApply(col.accessor)}>تصفية</button>
                    </div>
                  )}
                </th>
              ))}
               <th className="p-3 w-10">
          
              </th>
            </tr>
            
          </thead>
          <tbody className="">


            {rows?.map((r) => (
              <tr key={r.id} className="border-t  border-gray-100 hover:bg-gray-50 cursor-pointer" onClick={() => pagination?.onRowClick?.(r)}>
                <td className="p-3 text-center">
                  <input type="checkbox" className="rounded border-gray-300" />
                </td>
                {columns.map((col, idx) => (
                  <td key={idx} className={col.className || "p-3 whitespace-nowrap text-gray-700"}>
                    {col.render ? col.render(r) : r[col.accessor]}
                 
                  </td>
                ))}
                <td className="p-3 text-gray-400 ">
                  <div className="relative">
                    <button
                      className="w-7 h-7 grid place-items-center rounded-md border border-gray-200 bg-white focus:outline-none"
                      onClick={() => {
                        setActiveMenu(r.id === activeMenu ? null : r.id);
                        if (r.id === activeMenu) {
                         setActiveMenu(null);
                        } else {
                         setActiveMenu(r.id);
                        }

                      }}
                    >
                      …
                    </button>
                    {activeMenu === r.id&& (
                      <div className="absolute z-10 left-0 mt-2 w-64 bg-white rounded-xl shadow-lg border border-gray-200 py-2 text-right">
                      {act?.map((action, idx) => (
                        <button
                          key={idx}
                          className="w-full text-right px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                          onClick={() => {
                            action.onClick(r);
                            setActiveMenu(null);
                          }}
                        >
                          {action.label}
                        </button>
                      ))}
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Pagination */}
      <div className="flex items-center justify-between px-4 md:px-6 py-3 text-sm text-gray-600">
        <div className="flex items-center gap-4">
          <div>{pagination?.label || "الصفحة 1 من 90"}</div>
          {pagination.onPerPageChange && (
            <div className="flex items-center gap-2">
              <select
                value={pagination.perPage}
                onChange={(e) => pagination.onPerPageChange(Number(e.target.value))}
                className="border border-gray-200 rounded-md px-2 py-1 text-sm"
              >
                <option value={5}>5 / صفحة</option>
                <option value={10}>10 / صفحة</option>
                <option value={15}>15 / صفحة</option>
                <option value={25}>25 / صفحة</option>
                <option value={50}>50 / صفحة</option>
                <option value={100}>100 / صفحة</option>
              </select>
            </div>
          )}
        </div>
        <div className="flex items-center gap-2">
          <button 
            className="px-2 py-1 rounded-md border border-gray-200" 
            onClick={() => pagination.onPageChange(pagination.current - 1)}
            disabled={pagination.current === 1}
          >
            «
          </button>
          {/* Improved pagination logic */}
          {(() => {
            const pages = pagination?.pages || [1, 2, 3];
            const current = pagination?.current || 1;
            const last = pagination?.last || pages[pages.length - 1] || 1;
            let pageButtons = [];
            if (last <= 5) {
              // Show all pages if 5 or less
              for (let n = 1; n <= last; n++) {
                pageButtons.push(n);
              }
            } else {
              // Always show first, last, current, and neighbors
              if (current <= 3) {
                pageButtons = [1, 2, 3, 4, '...', last];
              } else if (current >= last - 2) {
                pageButtons = [1, '...', last - 3, last - 2, last - 1, last];
              } else {
                pageButtons = [1, '...', current - 1, current, current + 1, '...', last];
              }
            }
            return pageButtons.map((n, idx) =>
              n === '...'
                ? <span key={"ellipsis-" + idx} className="px-2">…</span>
                : <button
                    key={n}
                    className={`px-2.5 py-1 rounded-md border ${n === current ? "bg-gray-900 text-white border-gray-900" : "border-gray-200"}`}
                    onClick={() => pagination?.onPageChange(n)}
                  >
                    {n}
                  </button>
            );
          })()}
          <button 
            className="px-2 py-1 rounded-md border border-gray-200" 
            onClick={() => pagination.onPageChange(pagination.current + 1)}
            disabled={pagination.current === pagination.last}
          >
            »
          </button>
        </div>
      </div>
    </div>
  );
}
